import { Skeleton, Text } from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { FormikProps } from "formik";
import { match } from "ts-pattern";
import { useOptions } from "../../../hooks/useOptions";
import { useSites } from "../../../services/projectService";
import { chakraStyles } from "../../../theme";
import { DashboardViewFormValues } from "../../../types/dashboardForm";
import { ProjectID } from "../../../types/project";

export function SelectSites({ formik, project }: { formik: FormikProps<DashboardViewFormValues>; project: ProjectID }) {
  const query = useSites(project);
  const options = useOptions(query);

  return match(query)
    .with({ isLoading: true }, () => (
      <Skeleton>
        <Select size="md" />
      </Skeleton>
    ))
    .with({ isError: true }, () => <Text color="red">Error loading sites</Text>)
    .otherwise(() => (
      <Select
        size="md"
        placeholder="Select Sites"
        options={options}
        isMulti
        onChange={(x) =>
          formik.setFieldValue(
            "sites",
            x.map((y: any) => y.value),
          )
        }
        value={options.filter((x: any) => formik.values.sites.includes(x.value))}
        colorScheme="brand"
        chakraStyles={chakraStyles}
      />
    ));
}
